import script from "./AudienceHistoricTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceHistoricTable.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceHistoricTable.vue?vue&type=style&index=0&id=bf39d482&lang=scss"

const __exports__ = script;

export default __exports__